const getSelectedItems = (items) => items.filter((item) => item.isSelected);

export default getSelectedItems;
